import React, { useRef, useState } from 'react';
import css from './TagsFilter.module.css';
import Select from 'react-select';
import './TagsFilter.css';
import searchBlack from './search_black.png';

const TagsFilter = (props) => {
  const { initialValues, placeholderKeyword = 'option', onSubmit } = props;
  const formattedInitialValues =
    initialValues?.pub_tags
      ?.replace('has_any:', '')
      ?.split(',')
      ?.map((v) => ({
        label: v,
        value: v,
      })) || [];

  const savedArray =
    typeof window !== 'undefined' && window.sessionStorage.getItem('dynamicSearchOptions');
  const defaultOptions = savedArray
    ? JSON.parse(savedArray)?.map((v) => ({
        label: v,
        value: v,
      }))
    : [];

  const handleChange = (v = []) => {
    if (v.length < 1) {
      onSubmit({ pub_tags: null });
      return;
    }
    const formattedTags = v.map((v) => v.value).join(',');
    onSubmit({ pub_tags: `has_any:${formattedTags}` });
  };

  return (
    <div className={css.fieldWrapper}>
      <Select
        isMulti
        options={defaultOptions}
        onChange={(newValue) => handleChange(newValue)}
        value={formattedInitialValues}
        placeholder="Search by location, type or capture method..."
        classNamePrefix="react-select"
      />
      <img src={searchBlack} className={css.searchIcon} />
    </div>
  );
};

export default TagsFilter;
